import Masonry from 'masonry-layout';

const newsGrid = document.querySelector('.news__grid');
if (newsGrid) {
  const msnry = new Masonry(newsGrid, {
    columnWidth: '.news__grid__sizer',
    itemSelector: '.news__grid__item',
    percentPosition: true,
  });

  msnry.once('layoutComplete', () => {
    newsGrid.classList.add('.news__grid--loaded');
  });

  msnry.layout();
}
